export const canadianProvinces = [
  'Alberta',
  'British Columbia',
  'Manitoba',
  'New Brunswick',
  'Newfoundland and Labrador',
  'Nova Scotia',
  'Ontario',
  'Prince Edward Island',
  'Quebec',
  'Saskatchewan',
]

export const canadianTerritories = [
  'Northwest Territories',
  'Nunavut',
  'Yukon',
]

export const canadianStates = [ ...canadianProvinces, ...canadianTerritories ]

export const clientStatusMappings = {
  buyout: {
    long: 'Buyout',
    status: [ null ],
    type: [ 'hold' ],
  },
  competitor: {
    long: 'Switched to a different factoring company',
    status: [ null ],
    type: [ 'released' ],
  },
  'FMCSA issue': {
    long: 'FMCSA issue',
    status: [ null ],
    type: [ 'hold' ],
  },
  'fraud investigation': {
    long: 'Fraud investigation',
    status: [ null ],
    type: [ 'hold' ],
  },
  'insurance issue': {
    long: 'Insurance issue',
    status: [ null ],
    type: [ 'hold' ],
  },
  'not submitting invoices': {
    long: 'Not submitting invoices',
    status: [ null ],
    type: [ 'hold' ],
  },
  'client limit exceeded': {
    long: 'Client limit exceeded',
    status: [ null ],
    type: [ 'hold' ],
  },
  'write off': {
    long: 'Write Off',
    status: [ null ],
    type: [ 'hold' ],
  },
  'other': {
    long: 'Other',
    status: [ null ],
    type: [ 'released', 'hold' ],
  },
  'out of business': {
    long: 'Lost authority',
    status: [ null ],
    type: [ 'released' ],
  },
  'possible double factor': {
    long: 'Possible double factor',
    status: [ null ],
    type: [ 'hold' ],
  },
  'requesting a loan': {
    long: 'Requesting a loan',
    status: [ null ],
    type: [ 'released' ],
  },
  'stopped factoring': {
    long: 'No longer factoring',
    status: [ null ],
    type: [ 'released' ],
  },
}

export const countries = [ 'US', 'CA' ]

export const LDFlags = {
  bankVerification: 'mobile-bank-verification',
  ingestAlongsideV2: 'ingest-alongside-v2',
  ingestThroughV2: 'ingest-through-v2',
  showRateIncreaseModal: 'show-rate-increase-pop-up',
  useTAPI: 'use-tapi',
  useV2: 'use-v2',
  useV2InvoiceListing: 'use-v2-listing',
  zendeskEnabledClients: 'zendesk-enabled-clients',
  v2Announcement: 'v2-announcement',
  staffAppV2: 'staff-app-v2',
}

export const states = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'District of Columbia',
  'Floria',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Main',
  'Maryland',
  'Massachussetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
]

export const statesAbbreviations = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
]

export const tooltips = {
  explanations: {
    reservesDashboard: {
      dilution: '(Total AR - Total Payments) / Total AR',
    },
    volumeDashboard: {
      avgClientsVolumeLast30Days: 'Total approved invoices divided by number of unique clients having submitted invoices in the last 30 days',
      avgDebtorsVolumeLast30Days: 'Total approved invoices divided by number of unique debtors having submitted invoices in the last 30 days',
      avgVolumeLast30Days: 'Average approved invoice amount over the last 30 days',
      contributingClientsThisMonth: 'Total number of clients contributing to this month\'s volume',
      newClientsThisMonth: 'Total number of clients who have submitted their first invoice this month',
      newVolumeThisMonth: 'Approved volume from clients who have submitted their first invoice this month',
      volumeRollingYear: 'Approved invoices over the last 365 days',
      volumeThisDay: 'Approved invoices today',
      volumeThisMonth: 'Approved invoices this month',
    },
  },
}
